import React, { Component } from 'react'
import { getGrantDashboard, getGrantDashboardCalendar, getGrantDashboardFullCharts } from '../services/dashboardOutorga'

const DEFAULT_STATE = {
    dashboard: [],
    isLoadingDashboard: false,
    filters: [],
    calendar: null,
    isLoadingCalendar: false,
    fullCharts: null,
    isLoadingFullCharts: false,
}

export const DashboardOutorgaContext = React.createContext(DEFAULT_STATE)

export class DashboardOutorgaContextProvider extends Component {
    state = {
        ...DEFAULT_STATE,
    }

    handleGetGrantDashboard = async () => {
        try {
            this.setState({
                isLoadingDashboard: true,
            })

            const response = await getGrantDashboard();
            this.setState({
                dashboard: response?.data?.outorgas,
                filters: response?.data?.filtros
            })

            return response;
        }
        catch (error) {
            console.error(error)
        } finally {
            this.setState({
                isLoadingDashboard: false,
            })
        }
    }

    handleGetGrantDashboardCalendar = async (grantId, payload) => {
        try {
            this.setState({
                isLoadingCalendar: true,
            })

            const response = await getGrantDashboardCalendar(grantId, payload);
            if (response.status == 200) {
                this.setState({
                    calendar: response?.data,
                })
            }
        }
        catch (error) {
            console.error(error)
        } finally {
            this.setState({
                isLoadingCalendar: false,
            })
        }
    }

    handleGetGrantDashboardFullCharts = async (grantId, payload) => {
        try {
            this.setState({
                isLoadingFullCharts: true,
            })
            const response = await getGrantDashboardFullCharts(grantId, payload);

            if (response.status == 200) {
                this.setState({
                    fullCharts: {
                        graficos: response?.data?.graficos,
                        resumoGeral: response?.data?.condicoes_ativas,
                        nome: response?.data?.nome,
                        horasPeriodo: response?.data?.horas_periodo,
                    },
                })
            }
        }
        catch (error) {
            console.error(error)
        } finally {
            this.setState({
                isLoadingFullCharts: false,
            })
        }
    }

    clearCalendar = () => {
        this.setState({
            calendar: null,
        })
    }

    clearFullCharts = () => {
        this.setState({
            fullCharts: null,
        })
    }

    render() {
        const value = {
            ...this.state,
            getGrantDashboard: this.handleGetGrantDashboard,
            getGrantDashboardCalendar: this.handleGetGrantDashboardCalendar,
            getGrantDashboardFullCharts: this.handleGetGrantDashboardFullCharts,
            clearCalendar: this.clearCalendar,
            clearFullCharts: this.clearFullCharts,
        }

        return (
            <DashboardOutorgaContext.Provider value={value}>
                {this.props.children}
            </DashboardOutorgaContext.Provider>
        )
    }
}